<template>
  <div>
        <b-form-select v-model="elementSettings.value" :class="errorClasses" :disabled="elementSettings.disabled">
            <b-form-select-option 
                :key="index" 
                :value="item.value" 
                :disabled="item.disabled"
                v-for="(item,index) in elementSettings.data"
            >{{item.text}}</b-form-select-option>
        </b-form-select>
        <div class="text-error-notification" v-if="isError && typeof elementSettings.errorMessage === 'string' && elementSettings.isValidated">{{elementSettings.errorMessage}}</div>
  </div>
</template>
<script>
import {
  BFormSelect,
  BFormSelectOption
} from 'bootstrap-vue'
export default {
  components: {
    BFormSelect,
    BFormSelectOption
  },
  props: {
    elementSettings: {
      required: true,
      type: Object
    },
    formSettings: {
      required: true,
      type: Object
    }
  },
  methods: {
    executeElementValidate () {
      this.elementSettings.isError = !this.validate(this.elementSettings, this.formSettings)
    }
  },
  computed: {
    isError: {
      cache: false,
      get () {
        this.elementSettings.isError = !this.validate(this.elementSettings, this.formSettings)
        return this.elementSettings.isError
      }
    },
    errorClasses: {
      cache: false,
      get () {
        if (typeof this.elementSettings.errorClasses === 'string') {
          if (this.elementSettings.isValidated && this.isError) {
            return this.elementSettings.errorClasses
          }
          return ''
        } else {
          return ''
        }
      }
    }
  }
}
</script>

<style>

</style>